export enum TvCardTypesEnum {
  TvEntityCard = 'tv-entity-card',
  TvEventCard = 'tv-event-card',
  TvFavoriteCard = 'tv-favorite-card',
  TvNavigationCard = 'tv-navigation-card',
  TvOriginalCard = 'tv-original-card',
  TvPaginationCard = 'tv-pagination-card',
  TvVideoCard = 'tv-video-card',
  TvButton = 'tv-button',
  TvBannerMessage = 'tv-banner-message',
}

export enum TvCardStylesEnum {
  Large = 'large',
  Medium = 'medium',
  Standard = 'standard',
  Small = 'small',
}

export enum TvButtonStylesEnum {
  Standard = 'standard',
  EditFavorites = 'edit-favorites',
  StickyHeader = 'sticky-header',
}

export enum MessageModelTypesEnum {
  Message = 'message',
}

export enum MessageModelStylesEnum {
  Alternate = 'alternate',
  Info = 'info',
  NoContent = 'no-content',
  NoResultsForDates = 'results:no-results',
  SearchNoResults = 'search:no-results',
}

export enum LinkModelTypesEnum {
  Link = 'link',
}

export enum LinkModelStylesEnum {
  BackButton = 'back-button',
  ButtonFilterClear = 'button:filter:clear',
  ButtonIconPrimary = 'button:icon-primary',
  ButtonIconPrimaryLarge = 'button:icon-primary:lg',
  ButtonIconPrimarySmall = 'button:icon-primary:sm',
  ButtonIconSecondary = 'button:icon-secondary',
  ButtonIconSecondaryLarge = 'button:icon-secondary:lg',
  ButtonIconSecondarySmall = 'button:icon-secondary:sm',
  ButtonIconTertiary = 'button:icon-tertiary',
  ButtonIconTertiaryLarge = 'button:icon-tertiary:lg',
  ButtonIconTertiarySmall = 'button:icon-tertiary:sm',
  ButtonPrimary = 'button:primary',
  ButtonPrimaryLarge = 'button:primary:lg',
  ButtonPrimarySmall = 'button:primary:sm',
  ButtonSecondary = 'button:secondary',
  ButtonSecondaryLarge = 'button:secondary:lg',
  ButtonSecondarySmall = 'button:secondary:sm',
  ButtonTag = 'button:tag',
  ButtonTertiary = 'button:tertiary',
  ButtonTertiaryLarge = 'button:tertiary:lg',
  ButtonTertiarySmall = 'button:tertiary:sm',
  Client = 'client',
  CtaButtonIconText = 'cta-button:icon-text',
  CtaPrimary = 'cta:primary',
  CtaSecondary = 'cta:secondary',
  CtaTertiary = 'cta:tertiary',
  DrillDownCell = 'drill-down-cell',
  DropdownItem = 'dropdown-item',
  Icon = 'icon',
  IconBottomLabel = 'icon-bottom-label',
  IconTextCell = 'icon-text-cell',
  IconTextCellDrillDown = 'icon-text-cell:drill-down',
  NavigationPrimary = 'navigation:primary',
  NavigationPrimaryAux = 'navigation:primary:aux',
  NavigationSub = 'navigation:sub',
  Open = 'open',
  OpenDrawer = 'open:drawer',
  Paginate = 'paginate',
  PaginationButton = 'pagination-button',
  Search = 'search',
  Shortcut = 'shortcut',
  Tab = 'tab',
}

export enum TvSpotlightModelStylesEnum {
  Entity = 'entity',
  EventHub = 'event-hub',
  NavHub = 'nav-hub',
  Standard = 'standard',
}

export enum RenderableComponentMetadataEnum {
  Accessibility = 'accessibility',
  AdTargeting = 'ad-targeting',
  Analytics = 'analytics',
  ApiCall = 'api-call',
  Calendar = 'calendar-metadata',
  DateParts = 'date-parts',
  Event = 'event-metadata',
  EventStatusParts = 'event-status-parts',
  HeadlineDetailParts = 'headline-detail-parts',
  HtmlMetaElement = 'html-meta-element',
  LegendParts = 'legend-parts',
  LiveBadge = 'live-badge-metadata',
  LiveEvent = 'live-event-metadata',
  LiveLike = 'livelike-metadata',
  OfferMetadata = 'offer-metadata',
  Seo = 'seo',
  Stream = 'stream-metadata',
  StreamAnalytics = 'stream-analytics',
  VideoAnalytics = 'video-analytics-metadata',
  Vod = 'vod-metadata',
}

export enum TvBadgeStyleEnum {
  DarkShadow = 'dark-shadow',
  LightShadow = 'light-shadow',
  Live = 'live',
  Standard = 'standard',
  Cancel = 'cancel',
  Alternate = 'alternate',
}

export enum EntityTypeEnum {
  League = 'league',
  Team = 'team',
  Category = 'category',
  Institution = 'institution',
  Conference = 'parent_conference',
}

export enum DevSettingTypeEnum {
  Enable = 'enable',
  Toggle = 'toggle',
}

export enum DevSettingIdEnum {
  EnableStaging = 'enable-staging',
  ToggleShowVideoStatistics = 'toggle-show-video-statistics',
}

export enum EntitlementsResourceType {
  LIVE_EVENT = 'liveEvent',
  NODE = 'node',
  SITE = 'site',
  ALL = '*',
}

export type TvBadgeStyle = `${TvBadgeStyleEnum}`
export type TvCardType = `${TvCardTypesEnum}`
export type TvCardStyle = `${TvCardStylesEnum}`
export type TvButtonStyle = `${TvButtonStylesEnum}`
export type MessageModelType = `${MessageModelTypesEnum}`
export type MessageModelStyle = `${MessageModelStylesEnum}`
export type LinkModelType = `${LinkModelTypesEnum}`
export type LinkModelStyle = `${LinkModelStylesEnum}`
export type TvSpotlightModelStyle = `${TvSpotlightModelStylesEnum}`
export type RenderableComponentMetadata = `${RenderableComponentMetadataEnum}`
export type DevSettingType = `${DevSettingTypeEnum}`
export type DevSettingId = `${DevSettingIdEnum}`
export type EntityType = `${EntityTypeEnum}`
